import React from 'react';

import * as S from './style';

function LoaderSkeleton() {
  return <S.LoaderWrapper />;
}

export { LoaderSkeleton };
